import { cardItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-500/15 text-accent-400 border border-accent-500/20 mb-3">
            <i className="ri-article-line mr-1"></i>深度内容
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            深度影评
          </h2>
          <p className="mt-2 text-sm text-foreground-500">专业影评人与资深影迷的深度解读</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cardItems.map((item) => (
            <a
              key={item.title}
              href="#cards"
              className="group flex flex-col rounded-xl overflow-hidden bg-background-50 border border-background-200/50 hover:border-primary-500/30 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-accent-500/85 text-background-50 text-xs font-medium">
                  {item.tag}
                </span>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-400 transition-colors line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-2 line-clamp-3 leading-relaxed flex-1">
                  {item.excerpt}
                </p>
                <p className="text-xs text-foreground-600 mt-3 pt-3 border-t border-background-200/50">
                  {item.date}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}